import { observer } from "mobx-react";
import React, { useEffect } from "react";
import ConfigurationStore from "../../stores/ConfigurationStore";
import GlobalStore from "../../stores/GlobalStore";
import { Link } from "react-router-dom";

function Sites(props) {
  useEffect(() => {
    ConfigurationStore.getSites();
    GlobalStore.pageName = "sites";
  }, []);

  const edit = (id) => {
    props.history.push(`/site/edit/${id}`);
  };

  const onDelete = (id) => {
    let r = window.confirm("Are you sure to delete this site?");
    if (r) {
      ConfigurationStore.deleteSite(id).then(() => {
        ConfigurationStore.getSites();
      });
    }
  };

  let { sites = [] } = ConfigurationStore;
  console.log(`sites from store: ${JSON.stringify(sites)}`);
  return (
    <React.Fragment>
      <div className="table-info">
        <table border="0" cellSpacing="0">
          <thead>
            <tr>
              <th>Site Name</th>
              <th>HS Site ID</th>
              <th>App Name</th>
              <th>Client</th>
              <th>Week</th>
              <th>SnapShot ID</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {sites &&
              sites.map((site) => {
                return (
                  <tr>
                    <td>{site.site_name}</td>
                    <td>{site.hubspot_site_id}</td>
                    <td>{site.app_name}</td>

                    <td>{site?.client_id}</td>
                    <td>{site?.week_ending}</td>
                    <td>{site?.hubspot_snapshot_id}</td>
                    <td>
                      <button
                        className="primarybtn"
                        onClick={() => edit(site._id)}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => onDelete(site._id)}
                        className="primarybtn delete-btn"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
            <tr>End of Sites </tr>
            <tr>This space if for adding sites</tr>
          </tbody>
        </table>

        <div className="bottom-button">
          <Link to="/site/add">
            <button className="primarybtn add-btn">+ Add Site</button>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
}

export default observer(Sites);
